import LeftArrow from "Assets/Icons/LeftArrow";
import SearchCrossIcon from "Assets/Icons/SearchCrossIcon";
import SearchIcon from "Assets/Icons/SearchIcon";
import Typography from "Components/CommonComponents/Typography";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  Offcanvas,
  OffcanvasHeader,
  Row,
  Spinner,
} from "reactstrap";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import "./index.css";
import FilterIcon from "Assets/Icons/FilterIcon";
import { useEffect, useState } from "react";
import DateRangeComponent from "utilFunctions/shared/DateRangeComponent";
import { subDays } from "date-fns";
import moment from "moment";
interface NotificationsFilterIF {
  openFormHandler: any;
  inputText: string;
  setInputText: any;
  handleInputTextHandler: any;
  isLoader: boolean;
  dateRanges: any;
  setDateRanges: any;
  clearInputHandler: any;
  open: boolean;
  setOpen: any;
}

const FilterDiv = styled<any>("div")`
  padding: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "8px 16px" : "8px"};
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "8px" : "0px"};
`;
const SearchInputDiv = styled<any>("div")`
  width: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "100%" : "100%"};
  position: relative;
`;
const NotificationsFilter = ({
  openFormHandler,
  inputText,
  setInputText,
  handleInputTextHandler,
  isLoader,
  dateRanges,
  setDateRanges,
  clearInputHandler,
  open,
  setOpen,
}: NotificationsFilterIF) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { screen }: any = useWindowSize();

  const navigate = useNavigate();
  const onRequestClose = () => {
    setIsOpen(!isOpen);
  };
  console.log(
    "deploye=====",
    ["xxl", "xl", "lg"].includes(screen),
    dateRanges,
    moment(dateRanges[0].startDate).valueOf()
  );
  const isFilterApplied = () => {
    if (dateRanges[0].startDate != null && dateRanges[0].endDate != null) {
      return true;
    } else if (inputText != "") {
      return true;
    }
    return false;
  };
  const debouncedSearchTerm = useDebounce(inputText, 500);
  useEffect(() => {
    if (debouncedSearchTerm) {
      handleInputTextHandler(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm]);
  return (
    <FilterDiv screen={screen}>
      <Offcanvas
        backdrop={true}
        className="w-100 filterSlider"
        isOpen={isOpen}
        direction="end"
        toggle={onRequestClose}
      >
        <OffcanvasHeader className="filterHeader w-100">
          <div className="d-flex mt-2 d-flex align-items-center mb-2 ml-2 justify-content-between">
            <div className="d-flex">
              <LeftArrow
                className={"cursorHoverCSS mr-2"}
                onClick={onRequestClose}
              />
              <Typography
                variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
                color="black"
              >
                Notification
              </Typography>
            </div>
            <div className="filterspanWidth pr-2" onClick={clearInputHandler}>
              Reset
            </div>
          </div>
          <div className="pl-3 pr-3 pt-4 d-flex flex-column gap-3">
            <DateRangeComponent
              dateRanges={dateRanges}
              setDateRanges={setDateRanges}
              open={open}
              setOpen={setOpen}
              isChecked={false}
              minDate={subDays(new Date(), 365)}
            ></DateRangeComponent>
            <SearchInputDiv screen={screen}>
              <input
                type="number"
                className="searchFilterInputTitle"
                placeholder={"Search Template ID"}
                value={inputText}
                onChange={(e) => {
                  const { value } = e.target;
                  setInputText(value);
                }}
              />
              <div className="notificationsIcon">
                {isLoader ? (
                  <Spinner color="info" size="sm"></Spinner>
                ) : (
                  <>
                    {inputText ? (
                      <SearchCrossIcon
                        className="cursorHoverCSS"
                        onClick={clearInputHandler}
                      />
                    ) : (
                      <SearchIcon
                        style={{
                          cursor: "pointer",
                        }}
                      />
                    )}
                  </>
                )}
              </div>
            </SearchInputDiv>
          </div>
        </OffcanvasHeader>
        <div className="filterFooter p-0">
          <Button
            color={
              isFilterApplied()
                ? "aeslPrimary footerAddCommentBtn"
                : "aeslDraft footerAddCommentBtn"
            }
            className="d-flex justify-content-center w-100"
            disabled={isFilterApplied() ? false : true}
            onClick={() => {
              handleInputTextHandler(inputText);
              onRequestClose();
            }}
          >
            Apply
          </Button>
        </div>
      </Offcanvas>
      <div className="d-flex align-items-center" style={{ width: "45%" }}>
        <LeftArrow
          className={"cursorHoverCSS mr-1"}
          onClick={() => {
            navigate(-1);
          }}
        />
        <Typography
          variant={["xs", "sm", "md"].includes(screen) ? "h6" : "h4"}
          color="black"
        >
          Push Notifications
        </Typography>
      </div>
      <div style={{ width: "55%" }}>
        <Row className="d-flex align-items-center">
          {["xxl", "xl", "lg"].includes(screen) ? (
            <>
              <Col xxl="4" xl="4" lg="4" md="4" xs="0" sm="0">
                <DateRangeComponent
                  dateRanges={dateRanges}
                  setDateRanges={setDateRanges}
                  open={open}
                  setOpen={setOpen}
                  isChecked={false}
                  minDate={subDays(new Date(), 365)}
                ></DateRangeComponent>
              </Col>

              <Col xxl="5" xl="5" lg="5" md="4" xs="0" sm="0">
                <div className="d-flex">
                  <SearchInputDiv screen={screen}>
                    <input
                      type="number"
                      className="searchFilterInputTitle"
                      placeholder={"Search Template ID"}
                      value={inputText}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value == "") {
                          clearInputHandler();
                        }
                        setInputText(value);
                      }}
                    />
                    <div className="notificationsIcon">
                      {isLoader ? (
                        <Spinner color="info" size="sm"></Spinner>
                      ) : (
                        <>
                          {inputText ? (
                            <SearchCrossIcon
                              className="cursorHoverCSS"
                              onClick={clearInputHandler}
                            />
                          ) : (
                            <SearchIcon
                              style={{
                                cursor: "pointer",
                              }}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </SearchInputDiv>
                  {isFilterApplied() && (
                    <div
                      onClick={() => {
                        clearInputHandler();
                      }}
                      className="d-flex justify-content-center align-items-center cursor-pointer"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <span className={"filterSpan pr-0 pl-1"}>Reset All </span>
                    </div>
                  )}
                </div>
              </Col>
            </>
          ) : (
            <Col
              xxl="3"
              xl="3"
              lg="3"
              md="2"
              xs="3"
              sm="3"
              className="pr-0 d-flex justify-content-end"
            >
              <FilterIcon onClick={onRequestClose}></FilterIcon>
            </Col>
          )}
          <Col xxl="3" xl="3" lg="3" md="4" xs="9" sm="9" className="pr-0">
            <Button
              className="pl-2"
              color="aeslPrimary"
              size="sm"
              outline
              onClick={openFormHandler}
            >
              Create Notifications
            </Button>
          </Col>
        </Row>
      </div>
    </FilterDiv>
  );
};
function useDebounce(value: any, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    if (value === "") {
      setDebouncedValue("");
      return;
    }
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}
export default NotificationsFilter;
